import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Material
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatChipsModule } from '@angular/material/chips';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatRippleModule } from '@angular/material/core';
import { MatListModule } from '@angular/material/list';
import { CdkAccordionModule } from '@angular/cdk/accordion';

// Shared components
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { BackButtonComponent } from './back-button/back-button.component';
import { PullToRefreshComponent } from './pull-to-refresh/pull-to-refresh.component';
import { ErrorDisplayComponent } from './error-display/error-display.component';
import { ProfileSelectionComponent } from './profile-selection/profile-selection.component';
import { SocioBirthdateValidationComponent } from './socio-birthdate-validation/socio-birthdate-validation.component';
import { GameScoresPopupComponent } from './game-scores-popup/game-scores-popup.component';
import { LinkifyPipe } from '../linkify.pipe';
import { ShortenUrlPipe } from './shorten-url.pipe';

const MATERIAL_MODULES = [
  MatIconModule, MatButtonModule, MatInputModule, MatFormFieldModule,
  MatSelectModule, MatCardModule, MatDividerModule, MatDialogModule,
  MatTooltipModule, MatProgressSpinnerModule, MatSnackBarModule,
  MatSlideToggleModule, MatRadioModule, MatCheckboxModule,
  MatExpansionModule, MatChipsModule, MatBadgeModule,
  MatDatepickerModule, MatNativeDateModule, MatTabsModule,
  MatTableModule, MatPaginatorModule, MatMenuModule,
  MatProgressBarModule, MatBottomSheetModule, MatStepperModule,
  MatButtonToggleModule, MatToolbarModule, MatRippleModule,
  MatListModule, CdkAccordionModule,
];

@NgModule({
  declarations: [
    EmptyStateComponent,
    BackButtonComponent,
    PullToRefreshComponent,
    ErrorDisplayComponent,
    ProfileSelectionComponent,
    SocioBirthdateValidationComponent,
    GameScoresPopupComponent,
    LinkifyPipe,
    ShortenUrlPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ...MATERIAL_MODULES,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ...MATERIAL_MODULES,
    EmptyStateComponent,
    BackButtonComponent,
    PullToRefreshComponent,
    ErrorDisplayComponent,
    ProfileSelectionComponent,
    SocioBirthdateValidationComponent,
    GameScoresPopupComponent,
    LinkifyPipe,
    ShortenUrlPipe,
  ]
})
export class SharedModule {}
